import React from "react";
import Tabs from "../components/Tabs";
import * as Hiragana from "../characters/hiragana";
import * as katakana from "../characters/katakana";
import JapanesesCharacterView from "../components/japaneseCharacterView";
import { HIRAGANA_TRANSLATION } from "../characters/translations/hiragana";
import { KATAKANA_TRANSLATION } from "../characters/translations/katakana";

const Japanese = ({ isEnglishLetter }: { isEnglishLetter: boolean }) => {
  const tabs = [
    {
      label: "Hiragana",
      content: (
        <JapanesesCharacterView
          currentRoute="hiragana"
          language={Hiragana}
          isEnglishLetter={isEnglishLetter}
          translationArray={HIRAGANA_TRANSLATION}
          rows={[
            ["a", "i", "u", "e", "o"],
            ["ka", "ki", "ku", "ke", "ko"],
            ["sa", "si", "su", "se", "so"],
            ["ta", "ti", "tu", "te", "to"],
            ["na", "ni", "nu", "ne", "no"],
            ["ha", "hi", "hu", "he", "ho"],
            ["ma", "mi", "mu", "me", "mo"],
            ["ya", "", "yu", "", "yo"],
            ["ra", "ri", "ru", "re", "ro"],
            ["wa", "", "", "", "wo"],
          ]}
        />
      ),
    },
    {
      label: "katakana",
      content: (
        <JapanesesCharacterView
          language={katakana}
          isEnglishLetter={isEnglishLetter}
          translationArray={KATAKANA_TRANSLATION}
          currentRoute="katakana"
          rows={[
            ["a", "i", "u", "e", "o"],
            ["ka", "ki", "ku", "ke", "ko"],
            ["sa", "si", "su", "se", "so"],
            ["ta", "ti", "tu", "te", "to"],
            ["na", "ni", "nu", "ne", "no"],
            ["ha", "hi", "hu", "he", "ho"],
            ["ma", "mi", "mu", "me", "mo"],
            ["ya", "", "yu", "", "yo"],
            ["ra", "ri", "ru", "re", "ro"],
            ["wa", "wi", "", "we", "wo"],
          ]}
        />
      ),
    },
  ];

  return (
    <div className="App">
      <Tabs tabs={tabs} parentLanguage="japanese" />
    </div>
  );
};

export default Japanese;
